import { StyledMouseHint } from './MouseHint.styled';

const MouseHint = ({ visible = true }) => {
  return (
    <StyledMouseHint $visible={visible}>
    <div className='mouse-hint-section'>
      <img className='mouse-hint-img' src='/assets/lkm.svg' />
      <div className='mouse-hint-text'>
        Hold
        <span> for orbit</span>
      </div>
    </div>
    <div className='mouse-hint-section'>
      <img className='mouse-hint-img' src='/assets/pkm.svg' />
      <div className='mouse-hint-text'>
        Hold
        <span> for pan</span>
      </div>
    </div>
    <div className='mouse-hint-section'>
      <img className='mouse-hint-img' src='/assets/scroll.svg' />
      <div className='mouse-hint-text'>
        Scroll
        <span> for zoom</span>
      </div>
    </div>
    </StyledMouseHint>
  );
};

export default MouseHint;
